import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import QRCode from "react-qr-code";
import {Input, message, Modal, Form,Alert } from 'antd'
import {withRouter} from "react-router-dom";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import './index.scss'
import warningIcon from "../../../assets/img/warning.png";


class MFAPage extends React.Component {
    constructor(props) {
        super()
        this.state = {
            loading: true,
            qrCodeVal: "",
            username: props.username,
            disabledMFA: true,
            thankYou: false,
            userCode: "",
            secret: "",
            showEnableMFA: false,
        }
        console.log(props)
        this.onCodeEnter = this.onCodeEnter.bind(this)
        this.setMFA = this.setMFA.bind(this)
        this.disableMFA = this.disableMFA.bind(this)
    }

    componentDidMount() {
        CloudFlyerAPI.new_user_account.me()
            .then(res => {
                console.log("MFA :" + res.data.mfa)
                var mfa = res.data.mfa
                if (!mfa) {
                    this.setState({showEnableMFA: true})
                    CloudFlyerAPI.user_account.generateMFA()
                        .then(res => {
                            var issuer = "WCSM";
                            var str = "otpauth://totp/" + this.state.username + "?secret=" + res.data + "&issuer=" + issuer;
                            this.setState({qrCodeVal: str, secret: res.data})
                        })
                        .catch(e => {
                            this.setMFAAgain();
                            console.log(e.status)
                        })
                }else{

                    this.setState({disabledMFA: false})
                }
            })
            .catch(this.handleError)
    }

    onCodeEnter = e => {
        console.log(e.target.value);
        this.setState({userCode: e.target.value})
    };

    setMFA() {
        var body = {
            enabled: true,
            userCode: this.state.userCode
        }
        console.log(body);
        CloudFlyerAPI.user_account.setMFA(body)
            .then(res => {
                console.log(res)
                this.setState({showEnableMFA: false, disabledMFA: false})
                message.success("MFA enabled successfully!")
            })
            .catch(this.handleError)
    }

    setMFAAgain() {
        CloudFlyerAPI.user_account.logout()
        if (window.appHistory) {
            window.appHistory.push(
                `/login?returnUrl=${window.location.pathname}`
            )
            return window.appHistory.go()
        }
    }

    disableMFA() {
        var body = {
            enabled: false,
            //userCode: this.state.userCode
        }
        console.log(body);
        CloudFlyerAPI.user_account.setMFA(body)
            .then(res => {
                this.setState({showEnableMFA: false, disabledMFA: true, thankYou:true})
                message.success("MFA disabled successfully!")
            })
            .catch(this.handleError)
    }

    handleError(e) {
        console.log(e.response.data.message);
    }

    render() {
        let html;
        if (this.state.showEnableMFA) {
            html = (

                <div className="qr-code-image">
                    <h3>1. Install a compatible app on your mobile device or computer such as Google Authenticator</h3>
                    <h3>2. Please scan this QR code</h3>
                    {this.state.qrCodeVal !== "" &&
                        <QRCode value={this.state.qrCodeVal}/>
                    }
                    <h3>3. Alternatively, you can type the secret key</h3>
                    <p>{this.state.secret}</p>
                    <h3>4. Type MFA code below</h3>
                    <Input placeholder="MFA Code" className="mfa-code" onKeyUp={this.onCodeEnter}/>
                    <div className="btn-wrapper">
                        <button className="ant-btn add-cloud-btn ant-btn-primary" onClick={this.setMFA}>Enable MFA</button>
                    </div>
                </div>);
        } else {

            if (!this.state.disabledMFA) {
                html = (<div className="disable-form">
                    {/* <h3>1. Type MFA code below</h3>
                    <Input placeholder="MFA Code" className="mfa-code" onKeyUp={this.onCodeEnter}/> */}
                    <div className="btn-wrapper">
                        <button className="ant-btn add-cloud-btn ant-btn-primary" onClick={this.disableMFA}>Disable MFA</button>
                    </div>
                </div>);
            } else if(this.state.thankYou) {
                html = (<div className="disable-form">
                    <Alert
                        message="MFA disabled successfully."
                        type="success"
                    />
                    <div className="btn-wrapper">
                        <button className="ant-btn add-cloud-btn ant-btn-primary margin-left-0" onClick={this.setMFAAgain}>Enable MFA</button>
                    </div>
                </div>);
            }
        }


        return (
            <div className='mfa-container'>
                <h2>MFA</h2>
                {html}
            </div>
        )
    }
}

export default withRouter(connect(({auth}) => {
    let user = auth.user;
    return {
        ...user,
    };
}, (dispatch) => bindActionCreators({}, dispatch))(MFAPage));